import { render } from "./SectionBorder.vue?vue&type=template&id=73503fc2"
const script = {}

import exportComponent from "/Users/saleem/Sites/unitedtours/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__